export const PrimaryPriceInformationEnum = {
  buy: 'buy',
  mainRent: 'mainRent',
  monthlyCosts: 'monthlyCosts',
  operationalCosts: 'operationalCosts',
  heatingCosts: 'heatingCosts',
  allInclusiveRent: 'allInclusiveRent',
  rentSurcharge: 'rentSurcharge',
  evb: 'evb',
  totalRent: 'totalRent',
  totalCosts: 'totalCosts',
  runningCostsPerQm: 'runningCostsPerQm',
  availableReserveFunds: 'availableReserveFunds',
  miscCosts: 'miscCosts',
  sumRent: 'sumRent',
  lease: 'lease',
  leaseHold: 'leaseHold',
  homeownersAssociationFee: 'homeownersAssociationFee',
  partialPayment: 'partialPayment',
  rentPerSquareMeter: 'rentPerSquareMeter',
  buyPerSquareMeter: 'buyPerSquareMeter',
  internalCommission: 'internalCommission',
  externalCommission: 'externalCommission',
  commission: 'commission',
  return: 'return',
  rent: 'rent',
  deposit: 'deposit',
  compensation: 'compensation',
};

export const RestrictedPrices = [
  PrimaryPriceInformationEnum.operationalCosts,
  PrimaryPriceInformationEnum.heatingCosts,
  PrimaryPriceInformationEnum.miscCosts,
  PrimaryPriceInformationEnum.rentPerSquareMeter,
  PrimaryPriceInformationEnum.buyPerSquareMeter,
  PrimaryPriceInformationEnum.deposit,
  PrimaryPriceInformationEnum.compensation,
];

// ---
// Constants
// ---

export const SearchParams = [
  'companyName',
  'zipCode',
  'page',
  'sort',
  'region',
  'spot',
];
export const SearchParamsEnum = {
  companyName: 'companyName',
  zipCode: 'zipCode',
  page: 'page',
  sort: 'sort',
  region: 'region',
  spot: 'spot',
};

export const ROUTE_HOME_BASE_PATH = '/';
export const ROUTE_RESULT_LIST_BASE_PATH = '/anbieter/suchen';
export const ROUTE_RESULT_LIST_PREFIX = 'anbieter/suchen/immobilienmakler';
export const ROUTE_RESULT_LIST_BASE_AUSTRIA_PATH =
  '/anbieter/suchen/immobilienmakler/oesterreich';
export const ROUTE_EXPOSE_BASE_PATH = '/anbieter';

// ---
// Sort.
// ---
export const SortEnum = {
  default: 'RANDOMIZED',
  companyName: 'NAME_ASC',
  companyNameDesc: 'NAME_DESC',
  zipCode: 'ZIP_CODE_ASC',
  zipCodeDesc: 'ZIP_CODE_DESC',
};
export const SortValues = Object.values(SortEnum);

export const SortLabels = {
  [SortEnum.default]: 'Standardsortierung',
  [SortEnum.companyName]: 'Name aufsteigend',
  [SortEnum.companyNameDesc]: 'Name absteigend',
  [SortEnum.zipCode]: 'Postleitzahl aufsteigend',
  [SortEnum.zipCodeDesc]: 'Postleitzahl absteigend',
};

// ---
// GAC Widget Config.
// ---
export const SEARCH_RIBBON_FORM_NAME = 'searchRibbon';

export const IMMO_MAKLER_SLUG = 'immobilienmakler';

export const ANBIETER_API_PREFIX = '/anbieter/api';

export const REALTOR_LEADS_LINK = '/lp/rle/maklerempfehlung-maklersuche.html';
export const REALTOR_PROFILE_PRO_FEATURE = 'REALTOR_PROFILE_PRO';

export const PsaSearchParamsEnum = {
  accessibility: 'accessibility',
  accountCwid: 'accountCwid',
  adtest: 'adtest',
  cellarArea: 'cellarArea',
  companyName: 'companyName',
  conditionAge: 'conditionAge',
  conditionType: 'conditionType',
  countryCode: 'countryCode',
  effectiveArea: 'effectiveArea',
  effectiveAreaFrom: 'effectiveAreaFrom',
  effectiveAreaTo: 'effectiveAreaTo',
  estateDetailType: 'estateDetailType',
  estateType: 'estateType',
  facilities: 'facilities',
  fittingCategory: 'fittingCategory',
  floor: 'floor',
  furnishing: 'furnishing',
  gclid: 'gclid',
  hasCommission: 'hasCommission',
  hasPriceOnRequest: 'hasPriceOnRequest',
  isInvestmentProperty: 'isInvestmentProperty',
  isVacationProperty: 'isVacationProperty',
  keywords: 'keywords',
  lift: 'lift',
  livingArea: 'livingArea',
  livingAreaFrom: 'livingAreaFrom',
  livingAreaTo: 'livingAreaTo',
  mainRentPrice: 'mainRentPrice',
  mainRentPriceFrom: 'mainRentPriceFrom',
  mainRentPriceTo: 'mainRentPriceTo',
  numberOfBalconies: 'numberOfBalconies',
  numberOfLoggia: 'numberOfLoggia',
  numberOfParkingSpaces: 'numberOfParkingSpaces',
  numberOfRooms: 'numberOfRooms',
  numberOfRoomsFrom: 'numberOfRoomsFrom',
  numberOfRoomsTo: 'numberOfRoomsTo',
  numberOfTerrace: 'numberOfTerrace',
  page: 'page',
  plotArea: 'plotArea',
  plotAreaFrom: 'plotAreaFrom',
  plotAreaTo: 'plotAreaTo',
  primaryPrice: 'primaryPrice',
  primaryPriceFrom: 'primaryPriceFrom',
  primaryPriceTo: 'primaryPriceTo',
  purchasePrice: 'purchasePrice',
  purchasePriceFrom: 'purchasePriceFrom',
  purchasePriceNet: 'purchasePriceNet',
  purchasePriceNetFrom: 'purchasePriceNetFrom',
  purchasePriceNetTo: 'purchasePriceNetTo',
  purchasePriceTo: 'purchasePriceTo',
  region: 'region',
  regions: 'regions',
  rentNetPerSquareMeter: 'rentNetPerSquareMeter',
  rentNetPerSquareMeterFrom: 'rentNetPerSquareMeterFrom',
  rentNetPerSquareMeterTo: 'rentNetPerSquareMeterTo',
  rentNetPrice: 'rentNetPrice',
  rentNetPriceFrom: 'rentNetPriceFrom',
  rentNetPriceTo: 'rentNetPriceTo',
  size: 'size',
  sort: 'sort',
  spot: 'spot',
  totalArea: 'totalArea',
  transferType: 'transferType',
  transferTypes: 'transferTypes',
  useAndEstateType: 'useAndEstateType',
  useType: 'useType',
  utm_campaign: 'utm_campaign',
  utm_content: 'utm_content',
  utm_medium: 'utm_medium',
  utm_source: 'utm_source',
  utm_term: 'utm_term',
  zipCode: 'zipCode',
};

const DEFAULT_SPOT = 'Österreich';
export const DEFAULT_PLZ_PREFIX = 'plz';
export const FALLBACK_HIERARCHY_ENTITY_NAMES = [DEFAULT_SPOT];

const MAIN_PROPERTY_TYPES = [
  PsaSearchParamsEnum.useType,
  PsaSearchParamsEnum.estateType,
  PsaSearchParamsEnum.transferType,
  PsaSearchParamsEnum.estateDetailType,
  PsaSearchParamsEnum.region,
  PsaSearchParamsEnum.spot,
  PsaSearchParamsEnum.zipCode,
  PsaSearchParamsEnum.page,
];

/**
 * Parameters expected to be included in the pretty URL slug.
 */
export const PRETTY_URL_ENCODED_PARAMS = [
  SearchParamsEnum.zipCode,
  SearchParamsEnum.region,
  SearchParamsEnum.spot,
];

export const PARAMS_DISPLAY_ORDER = [...MAIN_PROPERTY_TYPES];

export const RangeLabels = {
  FROM: 'ab',
  TO: 'bis',
};
